import apiFetch from '../apiFetch'

export default function (token, signatureEntityId) {
  return apiFetch({
    endPoint: `SignEntity/${signatureEntityId}`,
    method: 'DELETE',
    body: null,
    token: token
  })
}
